import axios, { AxiosResponse } from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';

import {
	GET_METRICS_FAILURE,
	GET_METRICS_REQUEST,
	GET_METRICS_SUCCESS
} from '../constants/metrics.constant'


const getMetricsRequest = () => {
	return {
		type: GET_METRICS_REQUEST,
	};
};

const getMetricsSuccess = (metricsData: AnyIfEmpty<object>) => {
	return {
		type: GET_METRICS_SUCCESS,
		payload: metricsData,
	};
};

const getMetricsFailure = (metricsError: string) => {
	return {
		type: GET_METRICS_FAILURE,
		payload: metricsError,
	};
};

export const getMetrics = (metricsDetails: { locationId: string[]; startDateTime: string, endDateTime: string, propertyStatus: string[], managementCompany: string[] }) => {

	return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
		dispatch(getMetricsRequest());
		axios
			.get(`/metrics`, {
				params: {
					locationIds: JSON.stringify(metricsDetails.locationId),
					startDateTime: metricsDetails.startDateTime,
					endDateTime: metricsDetails.endDateTime,
					propertyStatus: JSON.stringify(metricsDetails.propertyStatus),
					managementCompany: JSON.stringify(metricsDetails.managementCompany)
				}
			})
			.then((response: AxiosResponse) => {
				if (response.data.statusCode === 200) {
					dispatch(getMetricsSuccess(response.data));
				} else {
					dispatch(getMetricsFailure(response.data.message));
				}
			})
			.catch((error) => dispatch(getMetricsFailure(error.response.data.message[0])));
	};
};